// UpdateInvoiceCoordinatesModal.js
import React, { useEffect } from 'react';
import { Modal, Form, Input, Button, Space, Card, Typography } from 'antd';
import { EnvironmentOutlined, CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const UpdateInvoiceCoordinatesModal = ({ isOpen, onCancel, onFinish, loading, form, data }) => {
    const { t } = useTranslation();
    // console.log(data);

    // Efecto para cargar los valores cuando se abre el modal
    useEffect(() => {
        if (isOpen && data) {
            form.setFieldsValue({
                latitude: data.latitude || '',
                longitude: data.longitude || '',
            });
        }
    }, [isOpen, data, form]);

    return (
        <Modal
            title={null}
            open={isOpen}
            onCancel={onCancel}
            footer={null}
            centered
            width={500}
            styles={{
                content: {
                    padding: 0,
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)'
                }
            }}
        >
            {/* Header */}
            <div style={{
                background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderRadius: '12px 12px 0 0',
                padding: '32px',
                color: 'white',
                textAlign: 'center'
            }}>
                <div style={{
                    background: 'rgba(255,255,255,0.2)',
                    borderRadius: '50%',
                    width: '64px',
                    height: '64px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    margin: '0 auto 16px'
                }}>
                    <EnvironmentOutlined />
                </div>
                <Typography.Title level={2} style={{
                    color: 'white',
                    margin: 0,
                    fontSize: '24px'
                }}>
                    {t('invoice.update_coordinates')}
                </Typography.Title>
                <Typography.Text style={{
                    color: 'rgba(255,255,255,0.8)',
                    fontSize: '14px',
                    display: 'block',
                    marginTop: '8px'
                }}>
                    {`Factura: ${data?.code || ''} - Actualizar coordenadas manualmente`}
                </Typography.Text>
            </div>

            {/* Form Content */}
            <Card style={{
                borderRadius: '0 0 12px 12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                border: 'none'
            }}>
            <Form form={form} onFinish={onFinish} layout="vertical">
                <Form.Item
                    name="latitude"
                    label={t('invoice.form_latitude')}
                    rules={[
                        { required: true, message: t('invoice.latitude_required') },
                        { 
                            pattern: /^-?\d+(\.\d{1,6})?$/, 
                            message: t('invoice.latitude_invalid') 
                        },
                    ]}
                >
                    <Input placeholder={t('invoice.form_latitude')} />
                </Form.Item>

                <Form.Item
                    name="longitude"
                    label={t('invoice.form_longitude')}
                    rules={[
                        { required: true, message: t('invoice.longitude_required') },
                        { 
                            pattern: /^-?\d+(\.\d{1,6})?$/, 
                            message: t('invoice.longitude_invalid') 
                        },
                    ]}
                >
                    <Input placeholder={t('invoice.form_longitude')} />
                </Form.Item>

                <Form.Item>
                    <div style={{
                        textAlign: "center",
                        paddingTop: '16px',
                        borderTop: '1px solid #f0f0f0',
                        marginTop: '24px'
                    }}>
                        <Space size="large">
                            <Button
                                icon={<CloseOutlined />}
                                onClick={onCancel}
                                size="large"
                                style={{
                                    height: '48px',
                                    paddingLeft: '32px',
                                    paddingRight: '32px',
                                    fontWeight: '500',
                                    borderRadius: '8px',
                                    border: '1px solid #ff4d4f',
                                    color: '#ff4d4f'
                                }}
                            >
                                {t('global.cancel')}
                            </Button>
                            <Button
                                type="primary"
                                icon={<SaveOutlined />}
                                htmlType="submit"
                                loading={loading}
                                size="large"
                                style={{
                                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                                    borderColor: '#253289',
                                    height: '48px',
                                    paddingLeft: '32px',
                                    paddingRight: '32px',
                                    fontWeight: '500',
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                                }}
                            >
                                {t('global.acept')}
                            </Button>
                        </Space>
                    </div>
                </Form.Item>
            </Form>
            </Card>
        </Modal>
    );
};

export default UpdateInvoiceCoordinatesModal;
